export default __webpack_public_path__ + "static/media/je-sais.02d78fa3.webp";